export const trackDisplayHaloEffect = (track) => {
    return track.impression({
        label: 'display-halo-effect',
    });
};
export const openHaloVerticalMenu = (track, verticalType) => {
    return track.click({
        label: `open-halo-vertical-menu | ${verticalType}`,
    });
};
export const trackHaloEffectDisplayTooltip = (track) => {
    return track.impression({
        label: 'halo-effect-display-tooltip',
    });
};
export const trackHaloEffectActionSetTooltipAsRead = (track) => {
    return track.click({
        label: 'halo-effect-set-tooltip-as-read',
    });
};
export const trackHaloEffectClickWikiInVertical = (track, verticalType, wikiName) => {
    return track.click({
        label: `halo-effect-click-on-wiki-in-vertical-menu | ${verticalType} | ${wikiName}`,
    });
};
export const trackHaloEffectClickVertical = (track, verticalType) => {
    return track.click({
        label: `halo-effect-click-vertical | ${verticalType}`,
    });
};
